import CryptoJS from 'crypto-js';

const SECRET_KEY = 'anti-po-secure-key-2026'; // In production, use env variable

export const encryptToken = (data) => {
    try {
        const jsonString = JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
        // FIXED: Replace standard Base64 characters with URL-safe ones to PREVENT 404 ERRORS
        // The server rejects '%' characters from encodeURIComponent
        return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (error) {
        console.error('Encryption failed:', error);
        return null;
    }
};

export const decryptToken = (token) => {
    try {
        if (!token) return null;
        // Reverse URL-safe replacements
        let base64 = token.replace(/-/g, '+').replace(/_/g, '/');
        // Add padding back if needed
        while (base64.length % 4) {
            base64 += '=';
        }

        const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
        const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
        if (!decryptedString) return null;

        try {
            return JSON.parse(decryptedString);
        } catch (e) {
            return decryptedString; // Fallback if not JSON
        }
    } catch (error) {
        console.error('Decryption failed:', error);
        return null;
    }
};
